import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const UserPage = lazy(() =>import('../../../pages/').then((module) => ({ default: module.UserPage })));


export const userChildrenRoutes = [
  {
    path: '',
    element: <Navigate to={'datos-productor'} />,
  },
  {
    path: 'datos-productor',
    element: <UserPage />,
  },
];
